import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';
import bus from './eventBus';
import 'animate.css';
import 'reset.css';
import './configs/index';
import store from './stores/index';
import NetVue from './net/http.vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import appVersion from './version';

const checkForNewVersion = () => {
  const currentVersion = localStorage.getItem('app-version');

  // 如果版本不匹配或首次加载
  if (currentVersion !== appVersion) {
    console.log(`[版本更新] 检测到新版本 ${appVersion} (旧版本: ${currentVersion})`);

    // 清理所有可能的旧缓存
    ['_moving-kite', '_home-state'].forEach(baseKey => {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith(baseKey)) {
          localStorage.removeItem(key);
        }
      });
    });

    // 保存新版本号
    localStorage.setItem('app-version', appVersion);

    // 强制刷新页面（确保使用新缓存）
    if (currentVersion) {
      window.location.reload();
    }
  }
};

// 应用启动时执行检查
checkForNewVersion();

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(bus);
Vue.use(NetVue);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(routes),
        tracingOrigins: ['localhost', 'movingkite.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    enabled: !process.env.VUE_APP_SENTRY_ENVIRONMENT.includes('local'),
  });
}

new Vue({
  render: h => h(App),
  router: routes,
  store: store,
}).$mount('#app');

routes.afterEach(to => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'MOVINGKITE | On-Demand Storage at $0.01/lb/day';
  }
});
